import { Card, CardContent, Typography, Grid } from "@mui/material";
import { InsuranceFees } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatCurrency, formatIsoDate, formatPercentage } from "../../../../utils/namesFormater";
import { formatDiscountTerms, formatDiscountType, formatFixedOrVariableSum, formatInsuranceSumRate, formatPayoutMethod, formatYesNo } from "../../../../utils/pensionEnumFormatter";

export interface InsuranceFeesFieldDef {
  field: keyof InsuranceFees;
  headerName: string;
  format?: 'currency' | 'isoDate' | 'default';
   renderCell?: (value: any) => string | number | React.ReactNode;
}

export const insuranceFeesFieldDefs: InsuranceFeesFieldDef[] = [
  { field: "insurance_percentage", headerName: "אחוז מביטוח יסוד" },
  { field: "salary_percentage", headerName: "אחוז מהשכר" },
  { field: "fee", headerName: "דמי ביטוח", format: "currency" },
  { field: "discount", headerName: "הנחה",renderCell: formatYesNo },
  { field: "insurance_discount_type", headerName: "סוג הנחת כיסוי", renderCell: formatDiscountType },
  { field: "discount_percentage", headerName: "אחוז הנחה",renderCell:formatPercentage },
  { field: "discount_value", headerName: "שווי הנחה", format: "currency" },
  { field: "tiered_discount", headerName: "הנחה מדורגת",renderCell: formatYesNo },
  { field: "discount_terms", headerName: "תנאי הנחה",renderCell:formatDiscountTerms },
  { field: "discount_end_date", headerName: "תום תקופת ההנחה", format: "isoDate" },
  { field: "insurance_sum_rate", headerName: "שיעור סכום ביטוח", renderCell: formatInsuranceSumRate },
  { field: "fixed_or_variable_sum", headerName: "סכום קבוע/משתנה", renderCell: formatFixedOrVariableSum },
  { field: "fixed_or_variable_rate", headerName: "שיעור קבוע/משתנה", renderCell: formatFixedOrVariableSum },
  { field: "premium_change_rate", headerName: "תדירות שינוי דמי הביטוח בשנים" },
  { field: "payment_stop_date", headerName: "תאריך הפסקת תשלום", format: "isoDate" },
  { field: "next_update_date", headerName: "עדכון הבא", format: "isoDate" }
];

interface Props {
  fees: InsuranceFees;
}

const InsuranceFeesDisplay: React.FC<Props> = ({ fees }) => {
  if (!fees || fees.fee == null) return null;

  return (
    <Card className="rounded-2xl shadow-md p-4">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          פרטי תשלום
        </Typography>
        <Grid container spacing={2}>
          {insuranceFeesFieldDefs.map(({ field, headerName, format, renderCell }) => {
            const value = fees[field];
            if (value == null) return null;

            let displayValue: string | number | React.ReactNode = value;
            if (renderCell) displayValue = renderCell(value);
            else if (format === "currency") displayValue = formatCurrency(value as number);
            else if (format === "isoDate") displayValue = formatIsoDate(value as string);

            return (
              <Grid item xs={12} sm={6} key={field}>
                <Typography variant="body2">
                  <strong>{headerName}:</strong> {displayValue}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default InsuranceFeesDisplay;